import { render, staticRenderFns } from "./SupplyChain.vue?vue&type=template&id=2a691b97&scoped=true&"
import script from "./SupplyChain.vue?vue&type=script&lang=js&"
export * from "./SupplyChain.vue?vue&type=script&lang=js&"
import style0 from "./SupplyChain.vue?vue&type=style&index=0&id=2a691b97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a691b97",
  null
  
)

export default component.exports